import {SERVER_URL, SERVER_PORT, SOCKET_SERVER_IP, SOCKET_SERVER_PORT, MIDDLE_WARE_SERVER_IP, MIDDLE_WARE_SERVER_PORT, JUNK, SECRET} from '@env';

const envVars = {
    SERVER_URL , SERVER_PORT, SOCKET_SERVER_IP, SOCKET_SERVER_PORT, MIDDLE_WARE_SERVER_IP, MIDDLE_WARE_SERVER_PORT, JUNK, SECRET
};

export default envVars;
